import { jwtDecode } from "jwt-decode";

export interface JwtPayload {
  nbf: string;
  exp: string;
  CustomerId: string;
  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role": string[]; // roles
  [key: string]: unknown;
}

export const decodeRoles = (token: string): string[] => {
  try {
    const decoded = jwtDecode<JwtPayload>(token);
    return decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] || [];
  } catch (error) {
    console.error("Invalid token:", error);
    return [];
  }
};

export const isTokenExpired = (token: string): boolean => {
  try {
    const decoded = jwtDecode<JwtPayload>(token);
    // exp is seconds since epoch, convert to milliseconds for Date.now()
    const exp = typeof decoded.exp === "string" ? parseInt(decoded.exp, 10) : decoded.exp;
    if (typeof exp !== "number" || isNaN(exp)) return true;
    const now = Math.floor(Date.now() / 1000);
    return exp < now;
  } catch (error) {
    console.error("Invalid token:", error);
    return true;
  }
};

export const isUser = (token: string): boolean => {
  return !isGuest(token);
};

export const isGuest = (token: string): boolean => {
  return token !== null && token !== undefined && !isTokenExpired(token) && decodeRoles(token).includes("Guest");
};

/**
 * Returns true if the token belongs to a vendor account.
 * NopCommerce assigns the "Vendors" system role to vendor customers.
 */
export const isVendor = (token: string): boolean => {
  return token !== null && token !== undefined && !isTokenExpired(token) && decodeRoles(token).includes("Vendors");
};